var map = {
	"./alarm.mp3": "69f8",
	"./alert.mp3": "f47c",
	"./alien.mp3": "331d",
	"./beep.mp3": "3bc3",
	"./bug.mp3": "2d21",
	"./call.mp3": "acba",
	"./dog.mp3": "a6a7",
	"./duck.mp3": "904e",
	"./horn.mp3": "1f53",
	"./message.mp3": "847e",
	"./ring.mp3": "a3cc",
	"./smartphone.mp3": "f265",
	"./spring.mp3": "fa47",
	"./telephone.mp3": "7b14",
	"./warning.mp3": "c417"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dd28";